<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr>
                <td *ngIf="hydrogenCapacity.powerInput">
                    <span>
                        <b>Power Input:&nbsp;</b>
                        {{hydrogenCapacity.powerInput}} MW
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.production">
                    <span>
                        <b>Production:&nbsp;</b>
                        {{hydrogenCapacity.production}} Tonnes/Annum
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.capacity">
                    <span>
                        <b>Capacity:&nbsp;</b>
                        {{hydrogenCapacity.capacity}} Tonnes/Annum
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.ammoniaCapacity">
                    <span>
                        <b>Ammonia Capacity:&nbsp;</b>
                        {{hydrogenCapacity.ammoniaCapacity}} Tonnes/Annum
                    </span>
                </td>
            </tr>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr>
                <td *ngIf="hydrogenCapacity.powerInput">
                    <span>
                        <b>Power Input:&nbsp;</b>
                        {{hydrogenCapacity.powerInput}} MW
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.production">
                    <span>
                        <b>Production:&nbsp;</b>
                        {{hydrogenCapacity.production}} Tonnes/Annum
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.capacity">
                    <span>
                        <b>Capacity:&nbsp;</b>
                        {{hydrogenCapacity.capacity}} Tonnes/Annum
                    </span>
                </td>
                <td *ngIf="hydrogenCapacity.ammoniaCapacity">
                    <span>
                        <b>Ammonia Capacity:&nbsp;</b>
                        {{hydrogenCapacity.ammoniaCapacity}} Tonnes/Annum
                    </span>
                </td>
            </tr>
        </table>
    </div>
</ng-template>